export default __webpack_public_path__ + "static/media/minibox_squirrel.8e223a25.png";